<template>
    <div class="col-12 col-md-6 d-flex align-items-center">
        <div class="w-100">
            <label for="urlVideo">
                Copie e cole o link do vídeo:
            </label>

            <div class="d-flex">
                <input
                    v-model="urlVideo"
                    type="text"
                    name="urlVideo"
                    id="urlVideo"
                >

                <button
                    class="ml-3 btn btn-sm btn-primario"
                    @click="addVideo()"
                    type="submit"
                    :disabled="validateButtonAddVideo"
                >
                    Salvar
                </button>
            </div>

            <div class="d-flex flex-column">
                <span class="mt-2">
                    Do Youtube ou Vimeo
                </span>

                <span class="mt-2 text-danger" v-if="errorMessage">
                    {{ errorMessage }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
import userModule from "../../store/modules/userModule.js";

export default {
    name: 'AddVideoInput',
    data() {
        return {
            urlVideo: '',
            errorMessage: '',
        }
    },
    mixins: [apiMixins],
    methods: {
        async addVideo() {
			this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

			const url = `/site/${this.$session.get("siteId")}/file/create`;

			const data = { uri: this.urlVideo };

			let response = await this.requestApiData(url, "post", data);

			if (response.status === "1") {
				userModule.state.newVideos.push({
					id: response.video.id,
					source: "Banco de videos",
					name: response.video.name,
					embed: response.video.filename,
					extension: response.video.extension,
					path: response.video.name,
					content: response.video.path
				});

				this.$parent.$emit('addVideo', {
					'id': response.video.id,
					'name': response.video.name,
					'embed': response.video.filename,
					'extension': response.video.extension,
					'url': response.video.path,
					'dataCreate': ''
				});

				this.urlVideo = '';
				this.errorMessage = '';

				this.$store.dispatch('userModule/UNSHIFT_UPLOADED_VIDEOS', [userModule.state.newVideos]);
			} else {
				this.errorMessage = 'Erro ao validar url do video, verifique e tente novamente.';
                this.urlVideo = '';
			}

            this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
		},
    },
    computed: {
        validateButtonAddVideo() {
            if (this.urlVideo == '') return true;
            return false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/AddVideoInput.vue